import { ArrowRightOutlined } from "@ant-design/icons"
import { Loader } from "lucide-react"
import type { ReactNode } from "react"

interface AuthSubmitButtonProps {
  isPending: boolean
  isDisabled: boolean
  children: ReactNode
}

export default function AuthSubmitButton({
  isPending,
  isDisabled,
  children
}: AuthSubmitButtonProps) {
  return (
    <button
      data-testid="auth-submit-button"
      type="submit"
      disabled={isDisabled}
      className={
        "w-full login-input-size rounded-xl font-medium text-sm flex items-center justify-center gap-2 transition-all login-cta-button " +
        (isPending
          ? "cursor-progress pointer-events-none opacity-70"
          : isDisabled
            ? "cursor-not-allowed"
            : "")
      }
    >
      {children}
      {isPending ? (
        <Loader className="animate-spin" size={16} />
      ) : (
        <ArrowRightOutlined />
      )}
    </button>
  )
}
